import { PropsWithChildren } from 'react';

import { Button as ButtonMui } from '@mui/material';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export enum ButtonTypes {
  SUBMIT = 'submit',
  RESET = 'reset',
  DEFAULT = 'button',
}

export enum ButtonColor {
  DEFAULT = 'primary',
  SECONDARY = 'secondary',
}

export type ButtonProps = MuiButtonProps & {
  label?: string;
  testId?: string;
};

export const Button = ({
  label,
  children,
  color = ButtonColor.DEFAULT,
  testId,
  ...rest
}: PropsWithChildren<ButtonProps>) => (
  <ButtonMui variant='contained' color={color} data-testid={testId} {...rest}>
    {children ?? label}
  </ButtonMui>
);
